import { Link, Navigate, NavLink } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import Button from "./NewButton";
import Links from "./NewLinks";
import "./Navbar.css";
import { projectAuth } from "../firebase/config";
import logo from "../assets/logonaranja.png";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import {
  Col,
  Container,
  Form,
  Modal,
  Nav,
  Navbar,
  Row,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { usePathname } from "../context/PathnameProvider";
import {
  getAvailablePrinters,
  impresoraConectada,
  printReceipt,
  requestPrinter,
  selectAvailablePrinter,
} from "./trucks/turnero/printerSandbox2";
import SelectorImpresora from "./SelectorImpresora";
import impresoraManager from "./ImpresoraManager";
import ColaImpresion from "./ColaImpresion";

export default function NavbarN() {
  const { user, register } = useAuthContext();
  const { setImpresi, setImpresoraID } = usePathname();
  const [modimpres, setModimpres] = useState(false);
  const [modcola, setModCola] = useState(false);
  const [conexionAct, setConexionAct] = useState(navigator.onLine);
  const [tipoImpresora, setTipoImpresora] = useState("USB");
  const [selectedDiv, setSelectedDiv] = useState("");
  const [tipoImpr, setTipoImpr] = useState("58");
  const [dispo, setDispo] = useState();
  const [connected, setConnected] = useState(false);
  const [listaDispo, setListaDispo] = useState([]);
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [estado, setEstado] = useState(impresoraManager.estado);
  const [impresoraConectada, setImpresoraConectada] = useState(
    impresoraManager.impresoraConectada,
  );
  const ordenPrueba = register
    ? {
        detalle: [
          {
            cantidad: 1,
            costo: "30",
            description: "Prueba",
            idv4: "47b04494-ca4d-4b45-b175-4ac68cb5f074",
            name: "Producto de prueba",
            ncosto: "Grande",
            note: "",
            status: "PENDIENTE",
            total: 30,
          },
        ],
        fecha: new Date(),
        id: "9b9eb3e1-ac60-44a9-880a-d4f3f7533d84",
        metodosPago: {
          efectivo: "100",
          tarjeta: "0",
          transferencia: "0",
          vale: "0",
        },
        idv4: "9b9eb3e1-ac60-44a9-880a-d4f3f7533d84",
        iva: 8,
        equivalenciapuntos: 1,
        folio: 1,
        not_rapdis: null,
        number: 1,
        ordenadoPor: "Web Rapdis",
        puesto: register.id,
        puesto_name: register.name,
        puesto_img: register.img,
        resena: null,
        resena_calificacion: null,
        reclamados: true,
        cambio: 70,
        cobro: 100,
        cobroiva: 7.407407407407419,
        puntosgenerados: 0,
        puntosusados: 0,
        status: "PENDIENTE",
        tipo_pago: "MIXTO",
        total: 30,
        user: null,
        user_name: "Publico en general",
      }
    : {};
  const [isSupported] = useState(() => "wakeLock" in navigator);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    let wakeLock = null;

    const requestWakeLock = async () => {
      if (!isSupported) return;
      try {
        wakeLock = await navigator.wakeLock.request("screen");
        setIsActive(true);

        wakeLock.addEventListener("release", () => {
          setIsActive(false);
        });
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    };

    requestWakeLock();

    const handleVisibilityChange = () => {
      if (wakeLock !== null && document.visibilityState === "visible") {
        requestWakeLock();
      }
    };

    const OffLine = () => {
      setConexionAct(false);
    };
    const OnLine = () => {
      setConexionAct(true);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    window.addEventListener("offline", OffLine);
    window.addEventListener("online", OnLine);

    return () => {
      if (wakeLock) {
        wakeLock.release();
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("offline", OffLine);
      window.removeEventListener("online", OnLine);
    };
  }, [isSupported]);

  useEffect(() => {
    getAvailablePrinters().then((dispos) => {
      setListaDispo(dispos);
    });
  }, [modimpres]);

  const logout = () => {
    projectAuth
      .signOut()
      .then(() => {
        Cookies.set("impAut", false);
        setImpresi(false);
        if (document.body.classList.contains("sidebar-expanded")) {
          document.body.classList.remove("sidebar-expanded");
          document.body.classList.add("sidebar close");
        }
        return <Navigate to="/login" />;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeTipo = async (val) => {
    if (val === "USB") {
      navigator.usb.getDevices().then((dispos) => {
        setListaDispo(dispos);
      });
    } else if (val === "COM") {
      window.navigator.serial.getPorts().then((dispos) => {
        setListaDispo(dispos);
      });
    } else if (val === "Bluetooth") {
      if (await navigator.bluetooth.getAvailability()) {
        navigator.bluetooth.getDevices().then((dispos) => {
          setListaDispo(dispos);
        });
      } else {
        alert(
          "No se encontro adaptador Bluetooth, asegurese de su dispositivo cuente con bluetooth y tenerlo activo.",
        );
      }
    }
    setDispo(undefined);
    setTipoImpresora(val);
    setSelectedDiv("Sin");
  };

  const connectDispo = async () => {
    selectAvailablePrinter(dispo.id)
      .then((val) => {
        console.log(impresoraConectada);
        console.log(val);
        if (val?.connected) {
          setShow(true);
          setImpresoraID(val.id);
          setConnected(true);
        }
      })
      .catch((error) => {
        setShowError(true);
        setConnected(false);
        console.log(error);
      });
  };

  const newConnection = async () => {
    requestPrinter(tipoImpresora)
      .then((val) => {
        console.log(impresoraConectada);
        console.log(val);
        if (val?.connected) {
          setShow(true);
          setConnected(true);
          setImpresoraID(val.id);
        }
      })
      .catch((error) => {
        setShowError(true);
        setConnected(false);
        console.log(error);
      });
  };

  const selectDevice = (val) => {
    if (val === "Sin") {
      setDispo(undefined);
    } else {
      setDispo(listaDispo[val]);
    }
    setSelectedDiv(val);
  };

  useEffect(() => {
    const quitarEstado = impresoraManager.on("estado", (nuevoEstado) => {
      setEstado(nuevoEstado.estado);
      setImpresoraConectada(nuevoEstado.impresoraConectada);
    });

    const quitarConexion = impresoraManager.on("conexion", (impresora) => {
      setImpresoraConectada(true);
      setEstado("conectada");
    });

    const quitarDesconexion = impresoraManager.on("desconexion", () => {
      setImpresoraConectada(false);
      setEstado("desconectada");
    });
    return () => {
      quitarEstado();
      quitarConexion();
      quitarDesconexion();
    };
  }, []);

  function EstadoConexion({ conectada, estado }) {
    let texto = "Desconectada";

    if (estado === "conectando") {
      texto = "Conectando...";
    }

    if (estado === "reconectando") {
      texto = "Reconectando...";
    }

    if (estado === "imprimiendo") {
      texto = "Imprimiendo...";
    }

    if (conectada) {
      texto = estado === "imprimiendo" ? "Imprimiendo..." : "Conectada";
    }

    return (
      <div
        style={{
          padding: "6px 10px",
          borderRadius: 20,
          background: conectada ? "#e5f7e5" : "#f1f1f1",
          color: conectada ? "#168000" : "#777",
          fontSize: 12,
          fontWeight: "bold",
          alignContent: "center",
        }}
        onClick={() => {
          setModCola(true);
        }}
      >
        ● {texto}
        <ColaImpresion compacta />
      </div>
    );
  }

  const customModalInfoStyles = {
    content: {
      width: "600px",
      height: "200px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };

  useEffect(() => {}, [window.location.hash]);

  return (
    <>
      <ToastContainer
        className="position-fixed p-3"
        style={{ zIndex: 9999, justifySelf: "center" }}
        position="top-center"
      >
        <Toast
          key={1}
          // onClose={() => {
          //   toast.visible = false;
          //   setToastes([...toastes]);
          // }}
          show={!conexionAct}
          bg="danger"
          // delay={15000}
          // autohide
        >
          <Toast.Header closeButton={false}>
            {/* <img src="/favicon.ico" className="rounded me-2" alt="" /> */}
            <strong style={{ textAlign: "center" }}>{"Sin conexion"}</strong>
            {/* <small className="text-muted">just now</small> */}
          </Toast.Header>
          <Toast.Body className="text-white">
            {"La pagina no cuenta con conexion a internet"}
          </Toast.Body>
        </Toast>
        <Toast
          key={1}
          onClose={() => {
            setShow(false);
          }}
          show={show}
          bg="success"
          delay={10000}
          autohide
        >
          <Toast.Header closeButton={false}>
            <strong style={{ textAlign: "center" }}>
              {"Conexion establecida con la impresora"}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            {"Conexion exisitosa!"}
          </Toast.Body>
        </Toast>
        <Toast
          key={1}
          onClose={() => {
            setShowError(false);
          }}
          show={showError}
          bg="danger"
          delay={10000}
          autohide
        >
          <Toast.Header closeButton={false}>
            <strong style={{ textAlign: "center" }}>
              {"Error al conectar con la impresora"}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            {
              "Revise que la impresora se encuentre conectada y encendida e intente de nuevo"
            }
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand>
            <NavLink to={user ? "/negocios" : "/"}>
              <img className="nav-logo" src={logo} alt="Logo" />
            </NavLink>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav />
            <Nav>
              {!user && (
                <>
                  <Links
                    redirectTo={"/#inicio"}
                    selected={window.location.hash === "#inicio"}
                    text={"Inicio"}
                  />
                  <Links
                    redirectTo={"/#caracteristicas"}
                    selected={window.location.hash === "#caracteristicas"}
                    text={"Caracteristicas"}
                  />
                  <Links
                    redirectTo={"/#nosotros"}
                    selected={window.location.hash === "#nosotros"}
                    text={"Nosotros"}
                  />
                  <Links
                    redirectTo={"/#planes"}
                    selected={window.location.hash === "#planes"}
                    text={"Planes y precios"}
                  />
                  <Links
                    redirectTo={"/#casos"}
                    selected={window.location.hash === "#casos"}
                    text={"Casos de exito"}
                  />
                </>
              )}
            </Nav>
            <Nav>
              {!user && (
                <>
                  <Button
                    redirectTo={"/login"}
                    text={"Iniciar sesión"}
                    filled={true}
                  />
                  <Button redirectTo={"/register"} text={"Registrar Cuenta"} />
                </>
              )}
              {user && (
                <>
                  {register && (
                    <>
                      <EstadoConexion
                        conectada={impresoraConectada}
                        estado={estado}
                      />
                      <Link
                        className="newbutton-style filled"
                        onClick={() => {
                          setModimpres(true);
                        }}
                      >
                        Agregar impresora
                      </Link>
                    </>
                  )}
                  {register && (
                    <Button
                      redirectTo={"/negocios"}
                      text={"Inicio"}
                      filled={true}
                    />
                  )}
                  {!register && (
                    <Button
                      redirectTo={"/signup"}
                      text={"Registro"}
                      filled={true}
                    />
                  )}
                  <Link
                    className="newbutton-style nonfilledtext-color"
                    onClick={logout}
                    to="/"
                  >
                    Cerrar sesion
                  </Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div style={{ height: "80px" }}>
        <Modal
          size="lg"
          style={customModalInfoStyles}
          show={modimpres}
          onHide={() => setModimpres(false)}
        >
          {/* <Modal.Header closeButton>
            <Modal.Title>Agregar impresora</Modal.Title>
          </Modal.Header> */}
          <Modal.Body>
            <SelectorImpresora />
          </Modal.Body>
          <Modal.Footer>
            <Row className="justify-content-center">
              <button
                onClick={() => {
                  setModimpres(false);
                }}
                className="newbutton-style filled"
              >
                Cerrar
              </button>
              {/* <button
                onClick={dispo ? connectDispo : newConnection}
                className="newbutton-style filled"
              >
                {dispo ? "Conectar" : "Seleccionar impresora"}
              </button>
              {connected && (
                <button
                  onClick={async () => {
                    impresoraManager.imprimir(
                      ordenPrueba,
                      register,
                      "Administrador",
                      false,
                      {},
                    );
                  }}
                  className="newbutton-style filled"
                >
                  {"Impresion de prueba"}
                </button>
              )} */}
            </Row>
          </Modal.Footer>
        </Modal>
        <Modal
          size="md"
          style={customModalInfoStyles}
          show={modcola}
          onHide={() => setModCola(false)}
        >
          <Modal.Body>
            <ColaImpresion />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
